import { render, staticRenderFns } from "./RDRs.vue?vue&type=template&id=18b9a7f0"
import script from "./RDRs.vue?vue&type=script&lang=ts"
export * from "./RDRs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports